import { render, staticRenderFns } from "./CompanyAssetAssignLogModal.vue?vue&type=template&id=2388a724&scoped=true"
import script from "./CompanyAssetAssignLogModal.vue?vue&type=script&lang=js"
export * from "./CompanyAssetAssignLogModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssetAssignLogModal.vue?vue&type=style&index=0&id=2388a724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388a724",
  null
  
)

export default component.exports